
export class UnitModel {
    id: number; // pk
    unitId: string; // unique key - the ref for all entities
    unitName: string;
    inaEnabled?: boolean;
    gtsEnabled?: boolean;

    constructor(id: number, unitId: string, unitName: string, inaEnabled?: boolean, gtsEnabled?: boolean) {
        this.id = id;
        this.unitId = unitId;
        this.unitName = unitName;
        this.inaEnabled = inaEnabled;
        this.gtsEnabled = gtsEnabled;
    }

}